import { Segmented } from "antd";
import { useWidth } from "@hooks";
import {
  DislikeOutlined,
  LikeOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "../../css/segmented-stk.css";

interface PropsI {
  status: string;
  handleStatus: (v: string) => void;
}

export const SegmentedStk = ({ status, handleStatus }: PropsI) => {
  const width = useWidth();

  if (width === "xs")
    return (
      <Segmented
        options={[
          { label: <CheckCircleOutlined />, value: "todos" },
          { label: <LikeOutlined />, value: "activos" },
          { label: <DislikeOutlined />, value: "inactivos" },
        ]}
        value={status}
        onChange={handleStatus}
        className="prod-segmented"
      />
    );

  return (
    <Segmented
      options={[
        { label: "Todos", value: "todos" },
        { label: "Activos", value: "activos" },
        { label: "Inactivos", value: "inactivos" },
      ]}
      value={status}
      onChange={handleStatus}
      className="prod-segmented"
    />
  );
};
